import { Button, ExternalLink, Line, ModalBody, ModalHeader, P } from "@sorcery/ui";

import { useModal } from "~/providers/ModalProvider";

export const DeckExportModal = () => {
  const { closeModal } = useModal();

  return (
    <div className="p-6">
      <ModalHeader title="Export Deck" />

      <ModalBody>
        {/* item */}
        <div className="mb-2 w-full">
          <P>
            Did you know you can play Sorcery decks from Curiosa.io on Table Top Simulator? All you
            need to do is copy and paste this deck's URL into the mod's deck importer tool!
          </P>

          <P>
            <span>Check out this guide</span>{" "}
            <ExternalLink
              href="https://www.youtube.com/watch?v=aEl-7eUMcf8"
              target="_blank"
              color="primary"
              rel="noreferrer"
            >
              here,
            </ExternalLink>
            <span> and download the mod </span>
            <ExternalLink
              href={"https://steamcommunity.com/sharedfiles/filedetails/?id=2884846136"}
              target="_blank"
              color="primary"
            >
              here.
            </ExternalLink>{" "}
          </P>
        </div>
      </ModalBody>

      {/* footer */}
      <Line />
      <div className="flex flex-row-reverse pt-4 gap-2">
        <Button onClick={closeModal} variant="secondary">
          Close
        </Button>
      </div>
    </div>
  );
};
